var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-position-wrapper singularity-position-wrapper--bottom-center"},[_c('div',{staticClass:"singularity-button-group"},[_c('SingularityCanvasButton',{attrs:{"icon":"PlusIconSolid","text":"Section"},on:{"click":_vm.addSection}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }